/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { BulbCkeditorModule } from 'src/ckeditor/bulb-ckeditor.module';
import { BulbImageModule } from 'src/app/image/bulb-image.module';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { AeroModule } from '../../../aero/aero.module';
import { EditorDialogService } from '../../editor/services/editor-dialog.service';
import { DeleteBlockComponent } from './delete-block-dialog/delete-block-dialog.component';
import {
  ImageCarouselCaptionDialogComponent,
} from './image-carousel-caption-dialog/image-carousel-caption-dialog.component';
import { OrientationDialogComponent } from './orientation-dialog/orientation-dialog.component';
import { BulbImageCropperModule } from '../../../app/image-cropper/bulb-image-cropper.module';

/**
 * Our Angular Dialog Feature Module for our new Editor, CKEditor.
 */
@NgModule({
  declarations: [
    DeleteBlockComponent,
    ImageCarouselCaptionDialogComponent,
    OrientationDialogComponent,
  ],
  exports: [
    DeleteBlockComponent,
    ImageCarouselCaptionDialogComponent,
  ],
  imports: [
    AeroModule,
    AngularCropperjsModule,
    BulbImageModule,
    CommonModule,
    BulbCkeditorModule,
    SvgIconComponent,
    FormsModule,
    TranslocoModule,
    BulbImageCropperModule,
  ],
  providers: [
    EditorDialogService,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class BulbCkeDialogModule { }
